import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import {ValidateButtonComponent} from '../../common/button/validate-button/validate-button.component';
import {CancelButtonComponent} from '../../common/button/cancel-button/cancel-button.component';
import {Location, NgIf} from '@angular/common';

@Component({
  selector: 'app-sub-navbar',
  imports: [
    ValidateButtonComponent,
    CancelButtonComponent,
    NgIf
  ],
  providers: [

  ],
  templateUrl: './sub-navbar.component.html',
})
export class SubNavbarComponent {

  router = inject(Router);
  location = inject(Location);

  @Input()
  buttonText = "Suivant"

  @Input()
  isValid = false

  @Input()
  authorizeBack = false

  @Output()
  onNext = new EventEmitter<void>()
}
